import {analyticsLogEvent} from '../api'

type Category = 'Size Chart Footer' | 'Size Chart'

const eventName = 'sizeChart'

/**
 * Tracks users who click on size chart inside the footer.
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {Category} params.category - Category of the event (e.g., "Size Chart Footer", "Size Chart")
 * @param {string} params.action - Description of the action performed (e.g., "open").
 */
export function analyticsEventSizeChartClick({category, action}: {category: Category; action: string}) {
    const eventDetails = {
        eventCategory: category,
        eventAction: action,
    }

    analyticsLogEvent(eventName, eventDetails)
}
